<template>
  <div
    class="game_pack_container d-flex-column justify-start align-start"
    style="margin-top: 30px"
  >
    <div class="d-flex-row space-between">
      <h5 class="t-white title-h5 font-family-1 f-w-600">
        {{ $t("main.boosters") }}
      </h5>
      <div class="d-flex-row justify-end">
        <button
          class="dark opacity regular-s f-w-600 height-40 border-none width-40 circular font-family-1"
          @click="swiperRef.slidePrev()"
        >
          <chev-left />
        </button>
        <button
          class="dark opacity regular-s height-40 width-40 border-none circular f-w-600 font-family-1"
          @click="swiperRef.slideNext()"
        >
          <chev-right />
        </button>
        <NuxtLinkLocale
          :to="`/${currentGameSlug}/boosters`"
          class="medium dark orange b-radius-6 regular-s f-w-600 font-family-1"
        >
          {{ $t("main.view_all") }}
        </NuxtLinkLocale>
      </div>
    </div>
    <div class="game_pack_cards_container" :style="{}">
      <ClientOnly>
        <swiper
          @swiper="onSwiper"
          :space-between="30"
          :slides-per-view="4.5"
          :centered-slides="false"
          :breakpoints="{
            200: {
              slidesPerView: 1.25,
            },
            500: {
              slidesPerView: 2.25,
            },
            768: {
              slidesPerView: 2.5,
            },
            1024: {
              slidesPerView: 3,
            },
            1250: {
              slidesPerView: 4.5,
            },
            1441: {
              slidesPerView: 5,
            },
            1900: {
              slidesPerView: 5.5,
            },
            2000: {
              slidesPerView: 6.5,
            },
            2400: {
              slidesPerView: 7,
            },
            2800: {
              slidesPerView: 8.5,
            },
          }"
        >
          <swiper-slide
            v-for="(booster, i) in response?.data?.boosters || []"
            :key="boosters.length"
          >
            <game-booster-card
              :image="booster.avatar"
              :language="booster.languages[0]"
              :username="booster.username"
              :rank="booster.game_ranks[0]?.image_dark"
              :rating="booster.reviews_score"
              :orders="booster.reviews_count"
              :is-online="booster.online === 1"
              :id="booster.id"
              :tier="booster?.rank?.image"
              :to="`/booster/${booster.slug}`"
            />
          </swiper-slide>
        </swiper>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import ChevLeft from "~/components/icons/ChevLeft.vue";
import ChevRight from "~/components/icons/ChevRight.vue";
import GameBoosterCard from "@/components/cards/GameBoosterCard.vue";
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
const { currentGameSlug } = useGameComposable();

const swiperRef = ref(null);
const isMounted = ref(false);
const boosters = ref([]);

// METHODS
const onSwiper = (swip) => {
  swiperRef.value = swip;
};

onMounted(() => {
  isMounted.value = true;
});
onBeforeUnmount(() => {
  isMounted.value = false;
});

// FETCHING BOOSTERS

const { data: response, error } = await useApiFetch("/api/get-boosters", {
  method: "post",
  fetchKey: `get-game-boosters-${currentGameSlug}`,
  body: {
    game: currentGameSlug,
    params: [
      "game_ranks",
      "languages",
      "reviews_score_and_count",
      "online_sort",
    ],
    count: 10,
    page: 1,
  },
  lazy: true,
});

// console.log(response.value);
if (response.value?.data) {
  boosters.value = response.value?.data?.boosters || [];
}
</script>
